/* eslint-disable simple-import-sort/imports */

// english namespaces imports
import AbbreviationsEnUS from './en-US/Abbreviations.json'
import CommonEnUS from './en-US/Common.json'
import RegionsEnUS from './en-US/Regions.json'
import DialogsEnUS from './en-US/Dialogs.json'
import ErrorsEnUS from './en-US/Errors.json'
import PluralsEnUS from './en-US/Plurals.json'
import SearchEnUS from './en-US/Search.json'
import TimeEnUS from './en-US/Time.json'
import TooltipsEnUS from './en-US/Tooltips.json'
import UtilsEnUS from './en-US/Utils.json'

// spanish namespaces imports
import AbbreviationsEsES from './es-ES/Abbreviations.json'
import CommonEsES from './es-ES/Common.json'
import RegionsEsES from './es-ES/Regions.json'
import DialogsEsES from './es-ES/Dialogs.json'
import ErrorsEsES from './es-ES/Errors.json'
import PluralsEsES from './es-ES/Plurals.json'
import SearchEsES from './es-ES/Search.json'
import TimeEsES from './es-ES/Time.json'
import TooltipsEsES from './es-ES/Tooltips.json'
import UtilsEsES from './es-ES/Utils.json'

// spanish namespaces imports
import AbbreviationsCaES from './ca-ES/Abbreviations.json'
import CommonCaES from './ca-ES/Common.json'
import RegionsCaES from './ca-ES/Regions.json'
import DialogsCaES from './ca-ES/Dialogs.json'
import ErrorsCaES from './ca-ES/Errors.json'
import PluralsCaES from './ca-ES/Plurals.json'
import SearchCaES from './ca-ES/Search.json'
import TimeCaES from './ca-ES/Time.json'
import TooltipsCaES from './ca-ES/Tooltips.json'
import UtilsCaES from './ca-ES/Utils.json'

// portuguese namespaces imports
import AbbreviationsPtPT from './pt-PT/Abbreviations.json'
import CommonPtPT from './pt-PT/Common.json'
import RegionsPtPT from './pt-PT/Regions.json'
import DialogsPtPT from './pt-PT/Dialogs.json'
import ErrorsPtPT from './pt-PT/Errors.json'
import PluralsPtPT from './pt-PT/Plurals.json'
import SearchPtPT from './pt-PT/Search.json'
import TimePtPT from './pt-PT/Time.json'
import TooltipsPtPT from './pt-PT/Tooltips.json'
import UtilsPtPT from './pt-PT/Utils.json'

// portuguese (brazil) namespaces imports
import AbbreviationsPtBR from './pt-BR/Abbreviations.json'
import CommonPtBR from './pt-BR/Common.json'
import RegionsPtBR from './pt-BR/Regions.json'
import DialogsPtBR from './pt-BR/Dialogs.json'
import ErrorsPtBR from './pt-BR/Errors.json'
import PluralsPtBR from './pt-BR/Plurals.json'
import SearchPtBR from './pt-BR/Search.json'
import TimePtBR from './pt-BR/Time.json'
import TooltipsPtBR from './pt-BR/Tooltips.json'
import UtilsPtBR from './pt-BR/Utils.json'

export const TRANSLATIONS_EN_US = {
  Abbreviations: AbbreviationsEnUS,
  Common: CommonEnUS,
  Regions: RegionsEnUS,
  Dialogs: DialogsEnUS,
  Errors: ErrorsEnUS,
  Plurals: PluralsEnUS,
  Search: SearchEnUS,
  Time: TimeEnUS,
  Tooltips: TooltipsEnUS,
  Utils: UtilsEnUS,
}

export const TRANSLATIONS_ES_ES = {
  Abbreviations: AbbreviationsEsES,
  Common: CommonEsES,
  Regions: RegionsEsES,
  Dialogs: DialogsEsES,
  Errors: ErrorsEsES,
  Plurals: PluralsEsES,
  Search: SearchEsES,
  Time: TimeEsES,
  Tooltips: TooltipsEsES,
  Utils: UtilsEsES,
}

export const TRANSLATIONS_CA_ES = {
  Abbreviations: AbbreviationsCaES,
  Common: CommonCaES,
  Regions: RegionsCaES,
  Dialogs: DialogsCaES,
  Errors: ErrorsCaES,
  Plurals: PluralsCaES,
  Search: SearchCaES,
  Time: TimeCaES,
  Tooltips: TooltipsCaES,
  Utils: UtilsCaES,
}

export const TRANSLATIONS_PT_PT = {
  Abbreviations: AbbreviationsPtPT,
  Common: CommonPtPT,
  Regions: RegionsPtPT,
  Dialogs: DialogsPtPT,
  Errors: ErrorsPtPT,
  Plurals: PluralsPtPT,
  Search: SearchPtPT,
  Time: TimePtPT,
  Tooltips: TooltipsPtPT,
  Utils: UtilsPtPT,
}

export const TRANSLATIONS_PT_BR = {
  Abbreviations: AbbreviationsPtBR,
  Common: CommonPtBR,
  Regions: RegionsPtBR,
  Dialogs: DialogsPtBR,
  Errors: ErrorsPtBR,
  Plurals: PluralsPtBR,
  Search: SearchPtBR,
  Time: TimePtBR,
  Tooltips: TooltipsPtBR,
  Utils: UtilsPtBR,
}
